import type { IconNode } from '../types';

/**
 * @name remove-formatting-square
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cmVjdCB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHg9IjMiIHk9IjMiIHJ4PSIyIiAvPgogIDxwYXRoIGQ9Ik03IDlWN2gxMHYyIiAvPgogIDxwYXRoIGQ9Ik0xMyA3IDggMTciIC8+CiAgPHBhdGggZD0iTTcgMTdoMyIgLz4KICA8cGF0aCBkPSJtMTcgMTQtMyAzIiAvPgogIDxwYXRoIGQ9Im0xNCAxNCAzIDMiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/remove-formatting-square
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const removeFormattingSquare: IconNode = [
  ['rect', { width: '18', height: '18', x: '3', y: '3', rx: '2', key: 'afitv7' }],
  ['path', { d: 'M7 9V7h10v2', key: 'oq86z9' }],
  ['path', { d: 'M13 7 8 17', key: 'eijp30' }],
  ['path', { d: 'M7 17h3', key: 'cep0ot' }],
  ['path', { d: 'm17 14-3 3', key: '1v81l4' }],
  ['path', { d: 'm14 14 3 3', key: 'vm23p3' }],
];

export default removeFormattingSquare;
